import DefineLowestMaxPrice from '@/brain/item-pricing/define-lowest-max-price'

export default ({
  finalQuotePrice = false,
  item,
  info,
  proposalMargin,
  decimalPrecision }) => {
  const proposalPrice = (item.price * ((proposalMargin / 100) + 1)).toFixed(decimalPrecision)
  const proposalTotalPrice = proposalPrice * info.itemInfo.quantity * info.itemInfo.factor
  const proposalPerc = (((proposalPrice * 100) / item.price) - 100).toFixed()
  const cmedPrice = item.cmedPrice || false

  const lowerValue = DefineLowestMaxPrice(cmedPrice, info.itemInfo.estimatedPrice)
  const isHigherThanMax = proposalPrice > lowerValue

  const quotationPayload = {
    quote: info.itemId,
    supplier: item.supplier,
    item: item.itemId,
    price: finalQuotePrice || item.price,
    priceTotal: item.price * info.itemInfo.quantity,
    isPriceGuaranted: !!item.isPriceGuaranted,
    cmedLab: item.cmedLab || false,
    cmedPrice: item.cmedPrice || false,
    cmedTotalPrice: item.cmedPrice * info.itemInfo.quantity,
    cmedPerc: (((item.cmedPrice * 100) / item.price) - 100).toFixed(),
    notQuote: !!item.notQuote,
    lab: item.lab,
    proposalPrice,
    proposalTotalPrice,
    proposalPerc,
    minimumPrice: proposalPrice,
    minimumTotalPrice: proposalTotalPrice,
    minimumPerc: proposalPerc,
    proposalIsHigherThanMaxprice: isHigherThanMax,
    minimumIsHigherThanMaxprice: isHigherThanMax
  }

  return quotationPayload
}



// WEBPACK FOOTER //
// ./src/view/item-pricing/helpers/PreparePayloadToSelect.js